module.exports = __webpack_public_path__ + "static/media/twilio.92b5eba8.svg";